import React from 'react'

function Plans() {
  return (
    <div>Plans</div>
  )
}

export default Plans